import PropTypes from "prop-types"

export const TABLE_FILTERS_SHAPE = PropTypes.shape({
  id: PropTypes.string,
  condition: PropTypes.func,
  value: PropTypes.any,
})
